import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Instantly scroll to top
      window.scrollTo(0, 0);
      
      // Also scroll after a slight delay to ensure lazy loaded components (like FAQ) are fully mounted and layout is stable
      const timer1 = setTimeout(() => window.scrollTo(0, 0), 50);
      const timer2 = setTimeout(() => window.scrollTo(0, 0), 200);
      
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
    }
  }, [pathname, hash]);

  return null;
}
